interface Config {
  baseApiUrl: string;
}

const targetConfig: Config = {
  baseApiUrl: `${process.env.REACT_APP_BASE_API_URL}/admin`,
};

export default targetConfig;
